export default __webpack_public_path__ + "static/worksans-regular-webfont-6cd1750b0bde62a9501ddc5d86f5c33c.woff2";